import variables from '../../variables.module.scss';

const MuiTypography = (breakpoints) => ({
  styleOverrides: {
    root: {
      fontFamily: variables.themeTypographyFont,
      fontSize: 14,
      '&.start-here-text': {
        color: variables.startHereFontColor,
        fontFamily: variables.fontBold,
        fontSize: '42px',
        textAlign: 'left',
        maxWidth: '642px',
        lineHeight: '52.5px',
        '&.green-bg': {
          backgroundColor: variables.startHereGreenColor,
        },
        '&.bigger-text': {
          fontSize: '48px',
          display: 'flex',
          [breakpoints.down('sm')]: {
            fontSize: 32,
            lineHeight: 'initial',
          },
          [breakpoints.down('md')]: {
            fontSize: 36,
            lineHeight: 'initial',
          },
        },

        [breakpoints.down('md')]: {
          fontSize: 28,
          lineHeight: 'initial',
        },
        [breakpoints.down('sm')]: {
          fontSize: 21,
        },
        '&.fist-line': {
          [breakpoints.down('md')]: {
            fontSize: 24,
          },
          [breakpoints.down('sm')]: {
            fontSize: 21,
          },
        },
      },
      '&.start-here-card': {
        textAlign: 'left',
        '&.arrow-text': {
          backgroundColor: variables.startHereArrowColor,
          fontFamily: variables.fontBold,
          color: variables.startHereFontColor,
          fontSize: '30px',
          lineHeight: '35px',
          [breakpoints.down('customheadermobile')]: {
            fontSize: 20,
          },
        },
        '&.lifetime-title': {
          fontFamily: variables.fontLight,
          color: variables.startHereLifetimeColor,
          fontSize: '40px',
          [breakpoints.down('md')]: {
            fontSize: 32,
            lineHeight: '32px',
          },
          lineHeight: '40px',
          maxWidth: '245px',
        },
        '&.benefit-title': {
          fontFamily: variables.fontBold,
          color: variables.startHereLifetimeColor,
          fontSize: '31px',
          [breakpoints.down('md')]: {
            fontSize: '24px',
          },
          lineHeight: '50px',
        },
        '&.description': {
          fontFamily: variables.fontRegular,
          color: variables.startHereDescriptionColor,
          fontSize: '24px',
          [breakpoints.down('sm')]: {
            fontSize: 21,
            marginTop: 30,
            marginBottom: 40,
            lineHeight: '26px',
          },
          lineHeight: '30px',
        },
        '&.disclaimer': {
          fontFamily: variables.fontRegular,
          fontSize: '14px',
          [breakpoints.down('md')]: {
            fontSize: '13px',
          },
          color: variables.startHereFontColor,
        },
        '&.scroll-down': {
          fontFamily: variables.fontSemiBold,
          fontSize: '16px',
          color: variables.startHereFontColor,
          lineHeight: '18px',
        },
      },
      '&.steps-wizard-steps': {
        fontFamily: variables.fontRegular,
        '&.question-text': {
          color: variables.stepWizardQuestionText,
          fontSize: 32,
          textAlign: 'left',
          lineHeight: '35px',
          [breakpoints.down('md')]: {
            fontSize: 24,
          },
          '&.no-wrap-text': {
            whiteSpace: 'nowrap',
          },
        },
        '&.question-desc': {
          color: variables.stepWizardQuestionDesc,
          fontSize: 18,
          marginTop: 10,
          lineHeight: '30px',
          maxWidth: 542,
        },
        '&.answer-text': {
          maxWidth: 273,
          '&.last-amount-input-label-width': {
            width: '130%',
          },
          '&.fixed-min-width': {
            [breakpoints.between('md', 'laptop')]: {
              width: 175,
            },
          },
          color: variables.stepWizardAnswerText,
          fontSize: 18,
          marginTop: 24,
          lineHeight: '30px',
        },
        '&.answer-slider-value': {
          fontSize: 24,
          color: variables.stepWizardSliderColor,
          marginTop: -10,
          marginLeft: 20,
        },
        '&.error-step-value': {
          color: variables.stepWizardQuestionDesc,
          fontSize: 15,
          marginTop: 0,
          height: 10,
        },
      },
      '&.did-you-know': {
        textAlign: 'center',
        color: variables.didYouKnowTextColor,
        fontSize: '20px',
        [breakpoints.down('md')]: {
          fontSize: 16,
        },
        '&.title': {
          fontFamily: variables.fontLight,
          fontSize: '48px',
          [breakpoints.down('md')]: {
            fontSize: 32,
          },
        },

        '&.description': {
          fontFamily: variables.fontRegular,
        },
        '&.description-bold': {
          fontFamily: variables.fontBold,
        },
      },
      '&.plan-gap': {
        textAlign: 'left',
        color: variables.planGapFontColor,
        fontSize: '24px',
        [breakpoints.down('customtablet')]: {
          fontSize: 24,
        },
        '&.description': {
          fontFamily: variables.fontRegular,
        },
        '&.description-bold': {
          fontFamily: variables.fontBold,
        },
      },
      '&.chart-title': {
        color: variables.benefitsHeaderColor,
        fontFamily: variables.fontBold,
        fontSize: '48px',
        textAlign: 'center',
        [breakpoints.down('md')]: {
          fontSize: 24,
        },
        '& .no-wrap': {
          whiteSpace: 'nowrap',
        },
      },
      '&.notfound-title': {
        color: variables.notFoundTitle,
        fontFamily: variables.fontBold,
        fontSize: '40px',
        textAlign: 'center',
        lineHeight: '45px',
        paddingTop: '30px',
      },
      '&.notfound-text': {
        color: variables.notFoundText,
        fontFamily: variables.fontRegular,
        fontSize: '24px',
        lineHeight: '34px',
        textAlign: 'center',
        paddingTop: '18px',
        paddingBottom: '32px',
      },
    },
    h1: {
      color: variables.headerTitleFontColor,
      fontFamily: variables.fontBold,
    },
    title: {
      fontFamily: variables.appBarTitleFont,
      color: variables.appBarTitleColor,
    },
    'page-title': {
      fontFamily: variables.fontBold,
      color: variables.benefitsHeaderColor,
      fontSize: 60,
      textAlign: 'center',
      [breakpoints.down('customheadermobile')]: {
        fontSize: 44,
      },
      [breakpoints.down('tabletportrait')]: {
        textAlign: 'center',
        fontSize: 32,
      },
      [breakpoints.down('sm')]: {
        textAlign: 'left',
        fontSize: 32,
      },
    },
    subtitle1: {
      fontFamily: variables.fontMedium,
    },
    subtitle2: {
      fontFamily: variables.fontRegular,
      color: variables.primary,
    },
    body1: {
      fontFamily: variables.fontRegular,
      fontSize: 14,
      letterSpacing: '0.00938em',
      lineHeight: 'normal',
      fontWeight: 'normal',
      [breakpoints.down('sm')]: {
        fontSize: 13,
      },
    },
    links: {
      fontFamily: variables.fontRegular,
      fontSize: 16,
      color: `${variables.linksVariantColor} !important`,
    },
  },
});

export default MuiTypography;
